var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10850",
    "data-name": "Group 10850",
    transform: "translate(-439.102 -246.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(442.102 249.102)",
    fill: "#a26dcb",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M272.608,406.977l7.729-9.995a2.111,2.111,0,0,0,.429-1.8,2.7,2.7,0,0,0-1.008-1.541l-1.3-1.03a2.272,2.272,0,0,0-3.332.227l-.868,1.126a.332.332,0,0,0,.055.463l2.24,1.8a.927.927,0,0,1,.289.559.83.83,0,0,1-.719.916.742.742,0,0,1-.569-.16l-2.305-1.835a.276.276,0,0,0-.374.048l-5.479,7.091a1.877,1.877,0,0,0-.352,1.583l.7,3.035a.352.352,0,0,0,.345.274l3.078-.038a1.847,1.847,0,0,0,1.433-.724Z",
    transform: "translate(184.683 -134.276)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.069674e8b5d1a248a385ed88f047f39a.svg";
export { ForwardRef as ReactComponent };